import styled from 'styled-components'

import { Button as LMFButton, fromMd } from '@syconium/little-miss-figgy'

export const Body = styled.div`
  display: flex;
  border-top: 1px solid ${o => o.theme.color.deprecated.stoneLight};
  padding-top: ${o => o.theme.spacing(6)};
`

export const Button = styled(LMFButton)`
  align-items: center;
  border: 2px solid black;
  display: flex;
  height: 56px;
  justify-content: center;
  padding: 0;
  width: 100%;
  &[aria-disabled='true'] {
    opacity: 0.7;
    background-color: ${o => o.theme.color.deprecated.stoneLight};
    border-color: ${o => o.theme.color.deprecated.stoneLight};
    color: ${o => o.theme.color.deprecated.obsidianLight};
  }

  ${fromMd} {
    height: 40px;
  }
`

const ButtonWrapper = styled.div`
  width: 50%;
`

export const LeftButtonWrapper = styled(ButtonWrapper)`
  padding-inline-end: ${o => o.theme.spacing(1)};
`

export const RightButtonWrapper = styled(ButtonWrapper)`
  padding-inline-start: ${o => o.theme.spacing(1)};
`
